import superjson from "superjson";

export const transformer = superjson;
